import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateDietExcludedAllergensDetailsArgs } from '../graphql/transformers'
import { UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS } from '../redux/action-types'

const useUpdateDietExcludedAllergensDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isExcludedAllergensDetailsLoading, excludedAllergensDetailsError } =
    useSelector(store => store.diets.diet)

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS_MUTATION,
        {
          id,
          data: transformToUpdateDietExcludedAllergensDetailsArgs(data),
        },
        dispatch,
        UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    {
      isLoading: isExcludedAllergensDetailsLoading,
      error: excludedAllergensDetailsError,
    },
  ]
}

export default useUpdateDietExcludedAllergensDetailsMutation
